import React, { forwardRef } from 'react';
import MUITooltip, {
  TooltipProps as MUITooltipProps,
} from '@material-ui/core/Tooltip';

interface TooltipProps extends MUITooltipProps {}

const Tooltip = forwardRef<React.ReactElement, TooltipProps>((props, ref) => {
  const { children, enterTouchDelay = 0, ...restProps } = props;

  return (
    <MUITooltip {...restProps} ref={ref} enterTouchDelay={enterTouchDelay}>
      {children}
    </MUITooltip>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
